import React from "react";
import {Carousel} from "primereact/carousel";

export interface CustomCarouselPropsI {
    numVisible: number,
    mobNumVisible?: number,
    tabNumVisible?: number,
    numScroll?: number,
    autoplayInterval?:number,
    showNavigators: boolean,
    showIndicators: boolean,
    carouselItems: any,
    itemTemplate: any
}

export const CustomCarousel = ({
                                   numVisible,
                                   mobNumVisible = 2,
                                   tabNumVisible = 3,
                                   numScroll,
                                   autoplayInterval,
                                   carouselItems,
                                   itemTemplate,
                                   showNavigators = false,
                                   showIndicators = false,
                               }: CustomCarouselPropsI) => {

    const responsiveOptions = [
        {
            breakpoint: '1199px',
            numVisible: 1,
            numScroll: 1,
            centerPadding: '0',
        },
        {
            breakpoint: '991px',
            numVisible: tabNumVisible,
            numScroll: 1
        },
        {
            breakpoint: '767px',
            numVisible: mobNumVisible,
            numScroll: 1
        }
    ];

    return (
        <>
            <Carousel autoplayInterval={autoplayInterval ? autoplayInterval : undefined} className="custom-carousel" value={carouselItems || []} numScroll={numScroll || 1}
                      numVisible={numVisible || 1} 
                      showNavigators={carouselItems?.length > numVisible} showIndicators={showIndicators}
                      responsiveOptions={responsiveOptions} itemTemplate={itemTemplate}/>
        </>
    );
};

export default CustomCarousel;